import { reenrolmentApi } from './clients';

/**
 * The card pictures the backend already holds.
 *
 * A parent who cannot see what they uploaded uploads it again, so these run when the screen
 * opens. A failure is not worth stopping the parent for — they can still upload — so it gives
 * back nothing and lets the form ask for the card as it did before.
 *
 * They return the files rather than two slots: whether a stored picture counts depends on the
 * card now on screen, which only the screen knows.
 */
const filesOrNone = async (request) => {
    try {
        const { data } = await request();
        return data?.files || [];
    } catch (error) {
        console.error('Could not load the cards already on file:', error.message);
        return [];
    }
};

export const fetchFamilyMedicareFiles = (parentId) =>
    filesOrNone(() => reenrolmentApi.get('/upload/Medicare-card', {
        params: { Parent_ID: parentId, card_type: 'family' },
    }));

export const fetchStudentMedicareFiles = (parentId, studentId) =>
    filesOrNone(() => reenrolmentApi.get('/upload/Medicare-card', {
        params: { Parent_ID: parentId, card_type: 'student', student_id: studentId },
    }));

export const fetchHccFiles = (parentId) =>
    filesOrNone(() => reenrolmentApi.get('/saveHCCpictures', {
        params: { Parent_ID: parentId },
    }));
